import {
	type AnalysisBatchRes,
	DsaiBatchDeleteRefusal,
	DsaiBatchNotDeletableCode,
	TaskStatus,
} from '@dealstack/shared/lib/backendClient';
import { isRecord } from '../dealstackAi.utils';
import type { DeleteFailure } from './batchDeletion.types';

type BatchReviewState = Pick<AnalysisBatchRes, 'status' | 'nothingToReview'>;

/** Finished with nothing to review: its results show "No transactions found" instead of the workspace. */
export const isNothingFound = ({ status, nothingToReview }: BatchReviewState): boolean =>
	status === TaskStatus.DONE && nothingToReview;

/** "Delete batch" applies to a failed or finished batch with nothing to review, as the server's guard. */
export const canDeleteBatch = ({ status, nothingToReview }: BatchReviewState): boolean =>
	nothingToReview && (status === TaskStatus.ERROR || status === TaskStatus.DONE);

const REFUSALS: ReadonlySet<unknown> = new Set(Object.values(DsaiBatchDeleteRefusal));

const isRefusal = (value: unknown): value is DsaiBatchDeleteRefusal => REFUSALS.has(value);

/** The server's reason for a refused delete; `other` for any other failure. */
export const deleteFailureOf = (error: unknown): DeleteFailure =>
	isRecord(error) &&
	error.code === DsaiBatchNotDeletableCode.BATCH_NOT_DELETABLE &&
	isRefusal(error.reason)
		? error.reason
		: 'other';
